import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetMigrationStatus } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchMigrationStatus = createAsyncThunk('get/migrationStatus', GetMigrationStatus);

export const FetchMigrationStatusSlice = createSlice({
	name: 'fetchMigrationStatus',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchMigrationStatus.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchMigrationStatus.rejected.toString()]: setAPIError,
		[fetchMigrationStatus.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchMigrationStatusSlice.name]: ReturnType<typeof FetchMigrationStatusSlice.reducer>;
}

export const migrationStatusSelector = (state: IStates): any => {
	return state[FetchMigrationStatusSlice.name] || {};
};

export const useMigrationStatus = (): any => useSelector(migrationStatusSelector);

export const getMigrationStatus =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchMigrationStatus(params));
		return;
	};

export const resetMigrationStatusList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchMigrationStatusSlice.actions.RESET());
		return;
	};
